import React, { useState } from 'react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { discogsAPI } from '../lib/api';
import SearchResults from './SearchResults';

export default function ManualSearch({ onSuccess }) {
  const [artist, setArtist] = useState('');
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);

  const handleSearch = async (e) => {
    e.preventDefault();
    if (!artist.trim() && !title.trim()) {
      toast.error('Please enter artist or album title');
      return;
    }

    setLoading(true);
    setResults([]);

    try {
      const params = {};
      if (artist.trim()) params.artist = artist.trim();
      if (title.trim()) params.title = title.trim();
      
      const res = await discogsAPI.search(params);
      
      if (res.data.results?.length > 0) {
        setResults(res.data.results);
      } else {
        toast.error('No albums found. Try different search terms.');
      }
    } catch (err) {
      if (err.response?.status === 503) {
        toast.error('Discogs API not configured. Please add DISCOGS_TOKEN.');
      } else {
        toast.error('Search failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  if (results.length > 0) {
    return (
      <SearchResults
        results={results}
        onSelect={onSuccess}
        onBack={() => setResults([])}
      />
    );
  }

  return (
    <form onSubmit={handleSearch} className="space-y-4">
      <div>
        <Label htmlFor="artist">Artist</Label>
        <Input
          id="artist"
          value={artist}
          onChange={(e) => setArtist(e.target.value)}
          placeholder="e.g. Miles Davis"
          className="h-12 bg-secondary border-border"
          data-testid="artist-input"
        />
      </div>
      
      <div>
        <Label htmlFor="title">Album Title</Label>
        <Input
          id="title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g. Kind of Blue"
          className="h-12 bg-secondary border-border"
          data-testid="title-input"
        />
      </div>

      <Button
        type="submit"
        disabled={loading || (!artist.trim() && !title.trim())}
        className="w-full gap-2 bg-primary text-primary-foreground"
        data-testid="search-manual-btn"
      >
        {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Search'}
      </Button>
    </form>
  );
}
